var generic = generic || {};
var site = site || {};

(function ($) {
  // Email signup JS related code
  site.emailSignupPromotional = {
    templateContainer: $(),

    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form')
          ? $emailContainerNode
          : $('form', $emailContainerNode);
        var $emailSuccess = $('.email-signup-promotional__success', $emailContainerNode);
        var $emailError = $('.email-signup-promotional__error', $emailContainerNode);
        var $emailInput = $('input[name="PC_EMAIL_ADDRESS"]', $emailContainerNode);
        var $errorList = $('.js-email-signup-promotional__errors', $emailContainerNode);
        var $smsErrorNode = $emailContainerNode.find('.js-sms-signup-promotional__error');
        var $smsInputNode = $emailContainerNode.find('.js-sms-signup-promotional__input');
        var $smsSignupTerms = $emailContainerNode.find('.sms-signup-promotional__terms');
        var $emailTncError = $emailContainerNode.find('.js-tnc-signup-promotional__errors');
        var $smsTncError = $emailContainerNode.find('.js-sms-tnc-signup-promotional__error');
        var colorboxSettings = {
          html: $emailSuccess.html(),
          className: 'confirmation-success-overlay-wrapper',
          width: '325px',
          height: '220px',
          fixed: true,
          maxWidth: '325px',
          maxHeight: '220px'
        };

        function toggleSMSFormElementsVisibility(val) {
          $smsErrorNode.addClass('hidden');
          $smsInputNode.removeClass('error');

          if (val) {
            colorboxSettings.html = $('.js-sms-signup-promotional__success', $emailContainerNode).html();
            $smsSignupTerms.show();
          } else {
            colorboxSettings.html = $emailSuccess.html();
            $('.js-sms-signup-promotional__checkbox', $emailContainerNode).prop('checked', false);
            $smsSignupTerms.hide();
          }
        }

        $smsInputNode.on('change keyup paste', function () {
          toggleSMSFormElementsVisibility($smsInputNode.val());
        });

        $emailForm.once('email-signup-promotional__form').submit(function (submitEvt) {
          submitEvt.preventDefault();
          $emailSuccess.add($emailError).addClass('hidden');
          $emailInput.removeClass('error');
          $emailForm.find('label, input').removeClass('error');
          $smsErrorNode.addClass('hidden').empty();
          $errorList.addClass('hidden').empty();
          $emailTncError.addClass('hidden').empty();
          $smsTncError.addClass('hidden').empty();

          // Transform string into array of form elements
          var params = {};

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });

          if ($emailContainerNode.find('.js-sms-signup-promotional__checkbox').prop('checked')) {
            params.SMS_PROMOTIONS = 1;
          } else {
            params.SMS_PROMOTIONS = 0;
          }

          var $emailSignupParentElement = $(
            '.js-email-signup-promotional',
            '.nodeblock-signup-form'
          ).parent(); // Need to "catch" the higher level element of this section

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
              // 1st condition satisfies in promotions page where as in footer it has three levels so introduced the OR condition
              if (
                $emailSignupParentElement.parent().hasClass('content') ||
                $emailSignupParentElement.hasClass('content')
              ) {
                // Only show the success message if the email_signup.success handlers haven't already done so
                if ($('#colorbox').css('display') !== 'block') {
                  $.colorbox(colorboxSettings);
                }
              } else {
                $.when($(document).triggerHandler('email_signup.success', [jsonRpcResponse])).then(
                  function () {
                    // Only show the success message if the email_signup.success handlers haven't already done so
                    if ($('#colorbox').css('display') !== 'block') {
                      $.colorbox({ html: $emailSuccess.html() });
                    }
                    if (
                      typeof site.track !== 'undefined' &&
                      site.track.emailSignup !== 'undefined' &&
                      typeof site.track.emailSignup === 'function'
                    ) {
                      site.track.emailSignup();
                    }
                  }
                );
              }
              $('.email_signup_sucess_popup .email-signup-promotional__success-text').on(
                'click',
                function () {
                  $.colorbox.close();
                }
              );
            },
            onFailure: function (jsonRpcResponse) {
              var error_message = jsonRpcResponse.getMessages();
              var i;
              var myErr;

              for (i = 0; i < error_message.length; i++) {
                myErr = error_message[i];

                if (myErr.key === 'invalid.pc_email_address.email_signup' || myErr.key === 'required.pc_email_address.email_signup') {
                  $emailInput.addClass('error');
                  $emailError.removeClass('hidden');
                  $errorList
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'required_dependency.validate_terms.terms.dependency.email_signup') {
                  $emailError.removeClass('hidden');
                  $emailTncError
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'invalid.phone2.sms') {
                  $smsInputNode.addClass('error');
                  $smsErrorNode
                    .append(myErr.text)
                    .removeClass('hidden');
                } else if (myErr.key === 'required_dependency.phone2.sms_promotions.dependency.sms') {
                  $smsTncError
                    .append(myErr.text)
                    .addClass('error')
                    .removeClass('hidden');
                }
              }
            }
          });
        });
      });
    },

    gdprRemInfoMessageBox: function () {
      var $infoMsgGDPR = $('.info-msg-gdpr');

      if ($infoMsgGDPR.get(0)) {
        $infoMsgGDPR.remove();
      }
    },

    gdprSetInfoBoxPosition: function (infoLink, infoMessageBox, infoMsgArrow, isMobile) {
      var infoLinkTop = infoLink.offset().top + infoLink.height() + infoMsgArrow.outerHeight(true);
      var infoLinkLeft = infoLink.offset().left;
      var infoMsgMaxWidth = parseInt(infoMessageBox.css('max-width').replace('px', ''));
      var infoMsgArrowMidPoint = infoMsgArrow.outerWidth(true) / 2;

      if (isMobile || navigator.userAgent.match(/iPad/)) {
        // This is the gap between popup and page in mobile. Ideal is 10px.
        var popupLeftPosMobile = 10;

        infoMsgArrow.css({
          left: infoLinkLeft - infoMsgArrowMidPoint + 'px'
        });
        infoLinkLeft = popupLeftPosMobile;
      } else if (
        infoMessageBox.outerWidth(true) === infoMsgMaxWidth &&
        infoLinkLeft + (infoMsgMaxWidth + 25) > screen.width
      ) {
        infoLinkLeft = infoLinkLeft - infoMessageBox.innerWidth() + infoMsgArrowMidPoint;
        infoMsgArrow.addClass('top-right-arrow');
      }
      infoMessageBox.css({
        top: infoLinkTop + 'px',
        left: infoLinkLeft + 'px'
      });
    },

    gdprToolTip: function (context) {
      if (Drupal.settings.globals_variables.gdpr_compliant) {
        var isMobile = Unison.fetch.now().name === 'small';
        var infoMessageBox = $('.info-msg-gdpr');

        $('body').on('click', function (e) {
          if (
            e.target.className !== 'info-msg-gdpr' &&
            e.target.className !== 'info-msg-gdpr__txt'
          ) {
            infoMessageBox.addClass('hidden');
          }
          if ($('html').hasClass('colorbox_scroll')) {
            $('html').removeClass('colorbox_scroll');
          }
        });

        $('.info-link-gdpr', context).on('click', function (e) {
          e.preventDefault();
          var infoLink = $(e.currentTarget);
          var $welcomeOverlay = $('.welcome15-overlay');

          if ($welcomeOverlay.is(':visible')) {
            $('html').addClass('colorbox_scroll');
          }
          site.emailSignup.gdprRemInfoMessageBox();

          $(
            "<div class='info-msg-gdpr'><div class='info-msg-gdpr__arrow'></div><div class='info-msg-gdpr__txt'></div></div>"
          ).appendTo('body');

          var infoBoxEle = $('#' + infoLink.attr('message-in'));
          var infoMsgArrow = $('.info-msg-gdpr__arrow');

          $('.info-msg-gdpr__txt', '.info-msg-gdpr').html(
            "<div class='info-msg-gdpr__close'>X</div>" + infoBoxEle.html()
          );

          $('#cboxClose, .info-msg-gdpr__close', context).on('click', function (e) {
            e.stopPropagation();
            site.emailSignup.gdprRemInfoMessageBox();
            if ($welcomeOverlay.is(':visible')) {
              $('html').removeClass('colorbox_scroll');
            }
          });

          site.emailSignup.gdprSetInfoBoxPosition(infoLink, infoMessageBox, infoMsgArrow, isMobile);
          $(window).on(
            'resize-debounced',
            site.emailSignup.gdprSetInfoBoxPosition(
              infoLink,
              infoMessageBox,
              infoMsgArrow,
              isMobile
            )
          );

          $('.info-msg-gdpr__txt span', '.info-msg-gdpr').on('mousedown', function () {
            window.location = $(this).attr('data-url');
          });

          $('.js-info-msg-gdpr__popuptxt').on('mousedown', function () {
            window.open(this.href, '_blank');
          });
        });
      }
    }
  };

  Drupal.behaviors.emailSignupFormPromotionalV1 = {
    attach: function (context) {
      site.emailSignupPromotional.templateContainer = $('.email-signup-promotional', context);
      site.emailSignupPromotional.initEmailSignup();
      site.emailSignupPromotional.gdprToolTip(context);
    }
  };
})(jQuery);
